import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Group, Heading, OverlayTriggerStateContext } from "react-aria-components";
import { CloseX } from "./CloseX.js";
import { Divider } from "./Divider.js";
import { FeaturedIcon } from "./FeaturedIcon.js";
import { base, content, supportingText as supportingTextClass, text, title as titleClass, xButton } from "./ModalHeader.css.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CloseButton = t0 => {
  const $ = _c(6);
  const {
    onClose,
    closeButton
  } = t0;
  const state = React.useContext(OverlayTriggerStateContext);
  let t1;
  if ($[0] !== onClose || $[1] !== state) {
    t1 = () => {
      if (onClose) {
        onClose();
      } else {
        if (state) {
          state.close();
        }
      }
    };
    $[0] = onClose;
    $[1] = state;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = closeButton === true ? "rounded" : closeButton;
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: xButton,
      children: /*#__PURE__*/_jsx(CloseX, {
        onPress: t1,
        variant: "gray",
        size: "l",
        type: t2
      })
    });
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
const BaseModalHeader = (t0, ref) => {
  const $ = _c(42);
  let featuredIcon;
  let onClose;
  let paddingBottom;
  let props;
  let supportingText;
  let t1;
  let t2;
  let t3;
  let title;
  if ($[0] !== t0) {
    ({
      type: t1,
      closeButton: t2,
      title,
      supportingText,
      featuredIcon,
      onClose,
      paddingBottom,
      divider: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = featuredIcon;
    $[2] = onClose;
    $[3] = paddingBottom;
    $[4] = props;
    $[5] = supportingText;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = title;
  } else {
    featuredIcon = $[1];
    onClose = $[2];
    paddingBottom = $[3];
    props = $[4];
    supportingText = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    title = $[9];
  }
  const type = t1 === undefined ? "leftAligned" : t1;
  const closeButton = t2 === undefined ? true : t2;
  const divider = t3 === undefined ? false : t3;
  let t4;
  if ($[10] !== paddingBottom) {
    t4 = base({
      paddingBottom
    });
    $[10] = paddingBottom;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== type) {
    t5 = content({
      type
    });
    $[12] = type;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== featuredIcon) {
    t6 = featuredIcon && /*#__PURE__*/_jsx(FeaturedIcon, {
      ...featuredIcon,
      size: "l"
    });
    $[14] = featuredIcon;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== type) {
    t7 = text({
      type
    });
    $[16] = type;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== title) {
    t8 = /*#__PURE__*/_jsx(Heading, {
      slot: "title",
      className: titleClass,
      children: title
    });
    $[18] = title;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== supportingText) {
    t9 = supportingText != null && supportingText.trim().length > 0 && /*#__PURE__*/_jsx("div", {
      className: supportingTextClass,
      children: supportingText
    });
    $[20] = supportingText;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t10 = /*#__PURE__*/_jsxs(Group, {
      className: t7,
      children: [t8, t9]
    });
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t5 || $[28] !== t6) {
    t11 = /*#__PURE__*/_jsxs("div", {
      className: t5,
      children: [t6, t10]
    });
    $[26] = t10;
    $[27] = t5;
    $[28] = t6;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== closeButton || $[31] !== onClose) {
    t12 = closeButton !== false && /*#__PURE__*/_jsx(CloseButton, {
      onClose: onClose,
      closeButton: closeButton
    });
    $[30] = closeButton;
    $[31] = onClose;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== divider) {
    t13 = divider !== false && /*#__PURE__*/_jsx(Divider, {
      variant: divider === true ? undefined : divider
    });
    $[33] = divider;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== props || $[36] !== ref || $[37] !== t11 || $[38] !== t12 || $[39] !== t13 || $[40] !== t4) {
    t14 = /*#__PURE__*/_jsxs(Group, {
      ref: ref,
      ...props,
      className: t4,
      children: [t11, t12, t13]
    });
    $[35] = props;
    $[36] = ref;
    $[37] = t11;
    $[38] = t12;
    $[39] = t13;
    $[40] = t4;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  return t14;
};
export const ModalHeader = /*#__PURE__*/React.forwardRef(BaseModalHeader);
//# sourceMappingURL=ModalHeader.js.map